import React from "react";
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ProdWidget from "./ProdWidget";
import InputNOL from "./InputNOL";
import { CloseRounded } from "@mui/icons-material";

const PrintItems = ({ values, setValues }) => {
  const handleInpNol = (e, item) => {
    setValues((prev) => ({
      ...prev,
      items: prev.items?.map((i) =>
        i.key === item.key ? { ...i, nol: e.target.value || 0 } : i
      ),
    }));
  };

  const handleDelete = (itemKey) => {
    setValues((j) => ({
      ...j,
      items: [...j.items.filter((i) => i.key !== itemKey)],
    }));
  };

  return (
    <TableContainer className="bs-secondary rounded-[15px] bg-inherit overflow-auto">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Product</TableCell>
            <TableCell align="center">Noumber of labels</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {values?.items.map((j, ind) => (
            <TableRow hover key={ind}>
              <TableCell>
                <span className="text-[17px] font-medium text-gray-500">
                  {values.items.length - ind}
                </span>{" "}
              </TableCell>
              <TableCell>
                <ProdWidget value={j} />
              </TableCell>
              <TableCell align="center">
                <InputNOL {...{ value: j, handleInpNol }} />
              </TableCell>
              <TableCell align="center">
                <IconButton
                  onClick={() => handleDelete(j.key)}
                  color="error"
                  size="small"
                >
                  <CloseRounded className="!text-[22px]" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PrintItems;
